import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
function People({ lang }) {

    const tabList = [
        {
            id: 1,
            to: null,
            title: 'མི་སྣ།'
        },
        {
            id: 2,
            to: '/',
            title: 'བླ་བརྒྱུད།'
        },
        {
            id: 3,
            to: null,
            title: 'ཚང་གསར་ཨོ་མགོན།'
        },
        {
            id: 4,
            to: null,
            title: 'ཚང་གསར་པད་འཇིགས།'
        },
        {
            id: 5,
            to: null,
            title: 'ཚང་གསར་འཆི་མེད་རྡོ་རྗེ།'
        },
        {
            id: 6,
            to: null,
            title: 'ཚང་གསར་བསྟན་གྲགས།'
        },
        {
            id: 7,
            to: null,
            title: 'ཚང་གསར་སྤྲུལ་སྐུ་ཀརྨ་ཨོ་རྒྱན།'
        },
        {
            id: 8,
            to: null,
            title: 'དཔོན་བརྒྱུད།'
        },
        {
            id: 9,
            to: null,
            title: 'འགྲམ་དཔོན་ཚང་།'
        },
        {
            id: 10,
            to: null,
            title: 'རྫ་ལྷུག་དཔོན་ཚང་།'
        },

    ]
    return (
        <>
            <Header />
            <Container className='kyagu'>
                <div className='kyaguBody pt-4 pr-5 pl-5'>
                    <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                        <Col className='align-items-center'>
                        </Col>
                    </Row>
                    {
                        lang === 'CH' ? (
                            // chinese Section
                            <>
                                <Row>
                                    <Col>
                                        <h3 className='text-left text-secondary'>Chinese Section</h3>

                                    </Col>
                                </Row>
                            </>
                        ) : (
                                // Tibetan Section
                                <>
                                    <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                        <Col className='align-items-center'>
                                            {/* Header Image */}
                                            {/* Title */}
                                            <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                མི་སྣ།
                    </h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                <Row>
                                                    <Col sm={5} md={3}>
                                                        <Nav variant='pills' className='flex-column '>
                                                            {/* Tabs */}
                                                            {
                                                                tabList.map((tabItem, index) => {
                                                                    return (
                                                                        <Nav.Item className='navItem' key='id'>
                                                                            <Nav.Link eventKey={index}>
                                                                                <h4>{tabItem.title}</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>)
                                                                })
                                                            }

                                                        </Nav>
                                                    </Col>

                                                    {/* Content */}
                                                    <Col sm={7} md={9}>
                                                        <Tab.Content className='tabContent'>
                                                            <Tab.Pane eventKey='1' className='tabPane'>

                                                                <p>
                                                                    <h1>བོད་ཡིག་</h1>
                                                                </p>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey='second' className='tabPane'>
                                                                <p>i am Singapore</p>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey='third' className='tabPane'>
                                                                <p>i am tibet</p>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey='forth' className='tabPane'>
                                                                <p>i am tibet</p>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Col>
                                    </Row>
                                </>
                            )
                    }

                </div>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang.lang,
    };
};

export default connect(mapStateToProps)(People);
